<template>
  <v-navigation-drawer app clipped dark>
    <v-list shaped>
      <v-list-item v-for="item in menu" :key="item.url"
        :to="`/eduedu-mais/${item.url}`" :disabled="item.disabled" link>
        <v-list-item-content>
          <v-list-item-title class="medium-text bold">{{
            item.title
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
>
<script>
export default {
  data() {
    return {
      menu: [{
        title: "Gerenciar chaves",
        url: "manage-keys",
        disabled: false,
      },
      {
        title: "Sincronizar assets",
        url: "sync-assets",
        disabled: false,
      }
      ]
    };
  },
};
</script>
